







































































import {
  getIntegralCardListData,
  getIntegralCardListApi,
  exportIntegralCardApi,
} from "@/api/integral";
import { exportLoop } from "@/utils/export";
import createCardDialog from "./createCardDialog.vue";
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "integralLogCard",
  components: {
    createCardDialog,
  },
})
export default class extends Vue {
  searchInfo: any = {};
  tableData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  getList(page: { page: number; page_size: number }) {
    const params: getIntegralCardListData = {
      page: page.page,
      page_size: page.page_size,
    };
    if (this.searchInfo.card_name) {
      params.card_name = this.searchInfo.card_name;
    }
    getIntegralCardListApi(params).then((res) => {
      res.data.list.map((item: any) => {
        item.loading = false;
      });
      this.tableData = res.data.list;
      this.page = res.data.page;
      this.total = res.data.total;
    });
  }
  downloadQRCode(scope: any) {
    // 点击限制
    this.tableData[scope.$index].loading = true;
    exportIntegralCardApi({
      card_id: scope.row.card_id,
    }).then((res) => {
      exportLoop(res.data.task_id, 1000, () => {
        this.tableData[scope.$index].loading = false;
      });
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
